import { useMemo } from 'react';
import flatten from 'lodash/flatten';
const COLORS = ['#7a61fa', // purple
'#11F0DF', // mint
'#179942', // green
'#f0631d', // orange
'#323e40', // dark gray
'#e84c48', // redish
'#f2d399', // beige
'#b56326', // brown
'#f25e7a', // pink
'#0e6973', // dark green
'#f2ae30', // yellow
'#d91438', // darker red
'#591202', // dark brown
'#F22E62' // dark pink
];
export default function useHighlights(collections, activeCollection, activeSelection) {
  let isMultiCollection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let maxCollections = arguments.length > 4 ? arguments[4] : undefined;
  const colors = useMemo(() => (isMultiCollection ? collections : collections[activeCollection]).map((_, i) => COLORS[i % COLORS.length]), [isMultiCollection, collections, activeCollection]);
  const selections = useMemo(() => {
    const setColor = createColorSetter(colors, isMultiCollection ? 'collection' : 'selection');
    const collectionAddresses = collections.slice(0, maxCollections).map((collection, collectionIdx) => collection.filter(selection => {
      // TODO support multi-sheet &
      // combined result selections
      return Boolean(selection) || selection.search(/^-1\./) === -1;
    }).map((cellReferences, selectionIdx) => ({
      active: activeCollection === collectionIdx && activeSelection === selectionIdx,
      color: setColor(collectionIdx, selectionIdx),
      cellReferences,
      details: {
        collectionIndex: collectionIdx,
        selectionIndex: selectionIdx
      }
    })));
    return flatten(collectionAddresses);
  }, [collections, colors, maxCollections, isMultiCollection, activeSelection, activeCollection]);
  return {
    selections,
    colors
  };
} // Factory for marking selections
// with the correct color based on
// if section has collection or selection
// based coloring requirements

function createColorSetter(colors, mode) {
  return function setColor(collectionIndex, selectionIndex) {
    return mode === 'collection' ? colors[collectionIndex] : colors[selectionIndex];
  };
}